import { render } from "./Menu.vue?vue&type=template&id=d912e538"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/layout/Menu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d912e538"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d912e538', __exports__)) {
    api.reload('d912e538', __exports__)
  }
  
  module.hot.accept("./Menu.vue?vue&type=template&id=d912e538", () => {
    api.rerender('d912e538', render)
  })

}


export default __exports__